import { useState } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import { getChangePassword } from 'store/recoverAccount-actions';

import ErrorMessage from 'uI/ErrorMessage/ErrorMessage';
import Loading from 'uI/Loading/Loading';
import classes from './RecoverAccountFourthStep.module.css';

const RecoverAccountFourthStep = props => {
  const { t } = useTranslation(['recoverAccount']);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] =
    useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [message, setMessage] = useState('');
  const { register, handleSubmit } = useForm();

  const onSubmit = async data => {
    if (data.userPassword !== data.userConfirmPassword) {
      setMessage('noMatch');
      // setMessage('Las contraseñas deben de coincidir.');
      setError(true);
      return false;
    }
    if (data.userPassword.length < 8) {
      setMessage('short');
      // setMessage(
      //   'Tu contraseña debe ser al menos con 8 caracteres.'
      // );
      setError(true);
      return false;
    }
    setIsLoading(true);
    (async () => {
      const setNewPassword = await getChangePassword(
        props.token,
        data.userPassword,
        data.userConfirmPassword,
        props.alias
      );
      if (setNewPassword === 'error') {
        setIsLoading(false);
        setMessage('error');
        setError(true);
      }
    })();
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleClickShowconfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  return (
    <>
      <form
        className={classes.formContainer}
        onSubmit={handleSubmit(onSubmit)}
      >
        <OutlinedInput
          className={classes.textField}
          {...register('userPassword')}
          placeholder={t('new_password')}
          type={showPassword ? 'text' : 'password'}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                onClick={handleClickShowPassword}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
        />
        <OutlinedInput
          className={classes.textField}
          {...register('userConfirmPassword')}
          placeholder={t('confirm_password')}
          type={showConfirmPassword ? 'text' : 'password'}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                onClick={handleClickShowconfirmPassword}
                edge="end"
              >
                {showConfirmPassword ? (
                  <VisibilityOff />
                ) : (
                  <Visibility />
                )}
              </IconButton>
            </InputAdornment>
          }
        />
        {!isLoading ? (
          <aside className={classes.btnContainer}>
            <Button
              className={classes.searchBtn}
              variant="contained"
              type="submit"
            >
              {t('save')}
            </Button>
          </aside>
        ) : (
          <Loading />
        )}
      </form>
      <p className={classes.complementaryText}>{t('extra_help')}</p>
      <p className={classes.complementaryText}>
        {t('you_can_go')}{' '}
        <span>
          {' '}
          <a
            className={classes.helpCenterBtn}
            href="http://ayuda.mayahii.com/"
            target="_blank"
            rel="noreferrer"
          >
            {' '}
            {t('help_center')}
          </a>
        </span>
      </p>
      {error && (
        <ErrorMessage
          open={error}
          message={
            message === 'noMatch'
              ? t('password_no_match')
              : message === 'short'
              ? t('short_password')
              : 'Hubo un probelma, intentalo más tarde'
          }
        />
      )}
    </>
  );
};

RecoverAccountFourthStep.propTypes = {
  // eslint-disable-next-line react/require-default-props
  token: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  alias: PropTypes.string
};

export default RecoverAccountFourthStep;
